var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _ellipse, _path43, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _path44, _path45, _ellipse8, _path46, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteModalBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 191,
    viewBox: "0 0 232 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.124 141.889C123.771 141.889 139.216 130.029 139.216 108.733C139.216 108.733 133.987 101.586 113.124 101.586C92.2612 101.586 87.0322 108.733 87.0322 108.733C87.0322 130.029 102.478 141.889 113.124 141.889Z",
    fill: "url(#paint0_linear_359_179975)",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8892 108.768C89.8989 108.755 89.9122 108.739 89.9293 108.718C89.9713 108.668 90.0363 108.592 90.1267 108.496C90.3074 108.304 90.5899 108.028 90.9945 107.696C91.8037 107.032 93.1017 106.143 95.0513 105.253C98.9505 103.474 105.458 101.689 115.878 101.689C126.298 101.689 132.806 103.474 136.705 105.253C138.655 106.143 139.953 107.032 140.762 107.696C141.166 108.028 141.449 108.304 141.63 108.496C141.72 108.592 141.785 108.668 141.827 108.718C141.844 108.739 141.857 108.755 141.867 108.768C141.85 129.993 126.454 141.785 115.878 141.785C105.302 141.785 89.9061 129.993 89.8892 108.768Z",
    fill: "url(#paint1_linear_359_179975)",
    stroke: "#A2A5D5",
    strokeWidth: 0.20614
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.329 140.829C100.715 137.657 90.0937 126.676 89.8921 109.238C91.52 112.782 94.7335 114.866 97.9894 116.555C98.7456 116.948 99.5054 117.319 100.249 117.683C100.341 117.728 100.432 117.773 100.523 117.817C101.354 118.224 102.161 118.623 102.919 119.032C104.436 119.853 105.747 120.713 106.649 121.761C110.643 126.397 111.552 131.187 111.465 134.817C111.421 136.633 111.127 138.159 110.845 139.231C110.704 139.767 110.565 140.189 110.463 140.477C110.411 140.621 110.369 140.731 110.339 140.805C110.336 140.814 110.332 140.822 110.329 140.829Z",
    fill: "url(#paint2_linear_359_179975)",
    stroke: "#A2A5D5",
    strokeWidth: 0.20614
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121.428 140.829C131.042 137.657 141.663 126.676 141.865 109.238C140.237 112.782 137.023 114.866 133.767 116.555C133.011 116.948 132.251 117.319 131.508 117.683C131.416 117.728 131.325 117.773 131.233 117.817C130.403 118.224 129.596 118.623 128.838 119.032C127.321 119.853 126.01 120.713 125.107 121.761C121.114 126.397 120.204 131.187 120.292 134.817C120.336 136.633 120.63 138.159 120.912 139.231C121.053 139.767 121.191 140.189 121.294 140.477C121.346 140.621 121.388 140.731 121.418 140.805C121.421 140.814 121.425 140.822 121.428 140.829Z",
    fill: "url(#paint3_linear_359_179975)",
    stroke: "#A2A5D5",
    strokeWidth: 0.20614
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8965 108.767C89.9061 108.755 89.9193 108.739 89.9361 108.718C89.9782 108.668 90.0431 108.592 90.1334 108.496C90.3141 108.304 90.5966 108.028 91.0011 107.696C91.8101 107.032 93.1078 106.143 95.057 105.253C98.9552 103.474 105.462 101.689 115.879 101.689C126.297 101.689 132.803 103.474 136.701 105.253C138.65 106.143 139.948 107.032 140.757 107.696C141.162 108.028 141.444 108.304 141.625 108.496C141.715 108.592 141.78 108.668 141.822 108.718C141.839 108.739 141.852 108.755 141.862 108.767C141.85 109.221 141.605 109.671 141.145 110.114C140.673 110.569 139.983 111.007 139.119 111.423C137.392 112.257 134.99 112.994 132.299 113.607C126.918 114.832 120.404 115.553 115.879 115.553C111.354 115.553 104.84 114.832 99.4591 113.607C96.7679 112.994 94.3658 112.257 92.6388 111.423C91.7749 111.007 91.0855 110.568 90.6135 110.114C90.1529 109.671 89.9083 109.221 89.8965 108.767Z",
    fill: "url(#paint4_linear_359_179975)",
    stroke: "#A2A5D5",
    strokeWidth: 0.20614
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.958 109.483C125.474 109.483 135.002 107.031 135.002 104.61C135.002 104.61 128.114 101.73 115.958 101.73C103.802 101.73 97.3242 104.397 97.3242 104.397C97.3242 106.818 106.442 109.483 115.958 109.483Z",
    fill: "#667FE1",
    fillOpacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.845 115.373C124.792 115.373 141.588 112.601 141.588 108.732C141.588 108.732 141.088 113.74 115.845 113.74C90.6023 113.74 90.1025 108.732 90.1025 108.732C90.1025 112.601 106.898 115.373 115.845 115.373Z",
    fill: "url(#paint5_linear_359_179975)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M123.848 118.077C122.355 118.218 120.161 117.691 120.08 116.831C120.08 116.831 120.758 116.272 123.651 115.998C126.544 115.725 127.316 116.146 127.316 116.146C127.394 116.977 125.341 117.936 123.848 118.077Z",
    fill: "url(#paint6_linear_359_179975)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M130.831 131.096C132.507 129.011 135.394 126.449 135.621 126.631C135.848 126.814 134.11 129.892 132.143 132.267C130.176 134.642 127.723 136.811 127.558 136.679C127.393 136.547 129.156 133.181 130.831 131.096Z",
    fill: "url(#paint7_linear_359_179975)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.3439 50.4975C85.6882 44.9881 80.9835 39.2925 73.713 39.2925C65.5154 39.2925 64.6674 50.4193 65.2682 56.7848C63.3923 57.7928 62.6533 58.4838 62.6533 58.4838C62.6533 86.5991 88.3811 103.647 113 103.647C137.619 103.647 163.346 86.5991 163.346 58.4838C163.346 58.4838 162.61 57.7954 160.742 56.7905C161.325 50.4096 160.444 39.3951 152.288 39.3951C145.06 39.3951 140.368 45.0246 137.704 50.5039C131.122 49.6302 122.99 49.0492 113 49.0492C103.034 49.0492 94.9168 49.6274 88.3439 50.4975Z",
    fill: "url(#paint8_linear_359_179975)",
    fillOpacity: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M163.245 58.9944H137.983C138.302 56.4653 139.706 51.6388 142.452 47.4197C145.24 43.1362 149.395 39.4983 155.182 39.4983C157.468 39.4983 159.17 40.3736 160.427 41.7709C161.687 43.1715 162.503 45.1013 163.003 47.212C163.992 51.3907 163.73 56.244 163.245 58.9944Z",
    fill: "url(#paint9_linear_359_179975)",
    stroke: "#A2A5D5",
    strokeWidth: 0.20614
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M163.167 58.5543C162.005 53.6199 158.255 49.2461 150.448 49.2461C146.616 49.2461 143.261 49.9567 140.351 51.1187V58.5543H163.167Z",
    fill: "url(#paint10_linear_359_179975)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5432 58.8916H93.8056C93.4866 56.3626 92.0816 51.536 89.3361 47.3169C86.5486 43.0334 82.3931 39.3956 76.6062 39.3956C74.3201 39.3955 72.6181 40.2708 71.3612 41.6681C70.1012 43.0687 69.2847 44.9985 68.7852 47.1092C67.7964 51.288 68.0582 56.1413 68.5432 58.8916Z",
    fill: "url(#paint11_linear_359_179975)",
    stroke: "#A2A5D5",
    strokeWidth: 0.20614
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5032 58.4517C69.6647 53.5173 73.4147 49.1436 81.222 49.1436C85.0542 49.1436 88.4086 49.8542 91.3193 51.0162V58.4517H68.5032Z",
    fill: "url(#paint12_linear_359_179975)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.65 58.53C65.6695 58.513 65.6979 58.4886 65.7356 58.4575C65.8177 58.3897 65.9441 58.2896 66.1197 58.1619C66.4709 57.9063 67.0188 57.54 67.8029 57.0996C69.371 56.219 71.8835 55.0424 75.6546 53.865C83.1969 51.5102 95.7727 49.1524 115.893 49.1524C136.014 49.1524 148.59 51.5102 156.132 53.865C159.903 55.0424 162.416 56.219 163.984 57.0996C164.768 57.54 165.316 57.9063 165.667 58.1619C165.843 58.2896 165.969 58.3897 166.051 58.4575C166.089 58.4886 166.117 58.513 166.137 58.53C166.109 86.5426 140.462 103.545 115.893 103.545C91.3247 103.545 65.6781 86.5426 65.65 58.53Z",
    fill: "url(#paint13_linear_359_179975)",
    stroke: "#A2A5D5",
    strokeWidth: 0.20614
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M166.24 58.4837C166.24 58.4837 164.749 57.5289 163.555 56.8149C164.16 67.7631 160.868 87.2413 136.155 99.8041C152.855 93.2847 166.24 78.7631 166.24 58.4837Z",
    fill: "#D185F2",
    fillOpacity: 0.3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4909 50.9984C88.5356 50.9855 88.6007 50.9672 88.6884 50.9445C88.88 50.8948 89.1792 50.8234 89.6075 50.7376C90.4642 50.566 91.8369 50.3368 93.8971 50.1074C98.0176 49.6485 104.886 49.1893 115.874 49.1893C126.862 49.1893 133.733 49.6484 137.856 50.1072C139.918 50.3366 141.292 50.5658 142.15 50.7374C142.578 50.8231 142.878 50.8945 143.07 50.9442C143.158 50.967 143.223 50.9853 143.268 50.9983C143.24 51.231 143.079 51.4953 142.766 51.7849C142.421 52.1035 141.907 52.4382 141.233 52.7777C139.887 53.4563 137.924 54.145 135.468 54.7614C130.558 55.994 123.691 56.9343 115.874 56.9343C108.057 56.9343 101.193 55.9705 96.2854 54.7262C93.8309 54.1039 91.8694 53.4123 90.5239 52.7381C89.8506 52.4007 89.3361 52.0699 88.9915 51.7574C88.6794 51.4745 88.5204 51.2192 88.4909 50.9984Z",
    fill: "url(#paint14_linear_359_179975)",
    stroke: "#A2A5D5",
    strokeWidth: 0.20614
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4808 51.5586C70.8386 54.3135 66.1885 58.6919 66.1885 58.6919C66.1885 80.2244 81.3584 95.186 99.4309 100.824C92.626 91.9891 80.509 69.7678 86.4808 51.5586Z",
    fill: "url(#paint15_linear_359_179975)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M115.894 99.2476C134.088 99.2476 150.656 90.1572 153.976 74.3996C154.761 70.6726 152.96 67.0234 149.443 65.5604C144.117 63.3444 133.958 60.6812 115.894 60.6812C97.83 60.6812 87.6711 63.3444 82.3449 65.5604C78.8283 67.0235 77.025 70.6735 77.8217 74.3981C81.1645 90.0262 97.7177 99.2476 115.894 99.2476Z",
    fill: "url(#paint16_linear_359_179975)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M146.5 66.6598C141.317 64.653 131.707 62.3318 114.98 62.3318C101.015 62.3318 92.0103 63.95 86.4014 65.6522C91.517 64.9564 103.011 65.0048 105.996 72.7819C113.136 91.3855 125.409 94.2401 130.531 94.2401C133.594 94.2401 136.269 92.7307 136.529 92.5796C143.305 88.5399 148.92 82.7133 150.981 75.538C152.054 71.7995 150.127 68.0642 146.5 66.6598Z",
    fill: "url(#paint17_linear_359_179975)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M115.893 64.7229C113.52 64.7229 110.142 64.0845 110.142 63.3308C110.142 63.3308 111.295 62.9014 115.893 62.9014C120.492 62.9014 121.645 63.3308 121.645 63.3308C121.645 64.059 118.267 64.7229 115.893 64.7229Z",
    fill: "url(#paint18_linear_359_179975)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M158.405 66.5568C158.878 63.9242 160.783 60.3992 161.339 60.4992C161.895 60.5991 161.861 63.9146 161.229 66.9339C160.597 69.9533 159.153 73.2868 158.749 73.2143C158.346 73.1419 157.932 69.1894 158.405 66.5568Z",
    fill: "url(#paint19_linear_359_179975)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0186 71.0843C73.8605 73.623 73.8707 77.6299 73.3343 77.8078C72.7978 77.9857 71.2443 75.0566 70.3572 72.1021C69.4701 69.1476 69.1468 65.529 69.5356 65.4001C69.9245 65.2711 72.1767 68.5455 73.0186 71.0843Z",
    fill: "url(#paint20_linear_359_179975)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9317 80.6753C76.5232 81.722 76.6016 83.6431 76.2568 83.8379C75.9121 84.0327 74.852 82.9438 74.2237 81.7068C73.5954 80.4698 73.3208 78.799 73.5707 78.6578C73.8206 78.5165 75.3401 79.6286 75.9317 80.6753Z",
    fill: "url(#paint21_linear_359_179975)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M115.877 50.5656C124.286 50.5656 130.655 50.035 130.655 49.704C130.655 49.704 127.688 49.2866 115.877 49.2866C104.065 49.2866 101.104 49.704 101.104 49.704C101.104 50.0218 107.467 50.5656 115.877 50.5656Z",
    fill: "url(#paint22_linear_359_179975)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M108.337 77.2812C108.372 77.6026 108.395 77.928 108.407 78.2569L107.634 78.2842C107.64 78.4375 107.642 78.5915 107.642 78.7464C107.642 78.9013 107.64 79.0554 107.634 79.2086L108.407 79.236C108.395 79.5648 108.372 79.8902 108.337 80.2116L107.569 80.1291C107.536 80.4372 107.492 80.7413 107.437 81.0408L108.198 81.1789C108.139 81.5024 108.069 81.8211 107.988 82.1344L107.24 81.9406C107.162 82.2399 107.074 82.5338 106.976 82.8218L107.707 83.0713C107.601 83.382 107.484 83.6864 107.357 83.9839L106.646 83.6792C106.525 83.9625 106.393 84.2388 106.252 84.5077L106.937 84.8669C106.784 85.1576 106.621 85.4403 106.448 85.7142L105.794 85.3014C105.63 85.5611 105.457 85.8121 105.275 86.0539L105.892 86.5189C105.695 86.7809 105.488 87.033 105.272 87.2744L104.696 86.7587C104.492 86.9862 104.28 87.2033 104.06 87.4093L104.588 87.9735C104.349 88.1975 104.101 88.4096 103.845 88.609L103.37 87.999C103.131 88.1854 102.884 88.3595 102.631 88.5207L103.046 89.1728C102.77 89.3483 102.487 89.51 102.197 89.6571L101.847 88.9675C101.579 89.1033 101.305 89.2254 101.026 89.333L101.303 90.0544C101 90.1714 100.69 90.2728 100.374 90.358L100.173 89.6117C99.8854 89.6893 99.5931 89.7521 99.2965 89.7994L99.4183 90.5628C99.0986 90.6138 98.7742 90.6483 98.4459 90.6656L98.4053 89.8936C98.2567 89.9014 98.1072 89.9053 97.9567 89.9053C97.8063 89.9053 97.6568 89.9014 97.5082 89.8936L97.4676 90.6656C97.1393 90.6483 96.8149 90.6138 96.4952 90.5628L96.617 89.7994C96.3204 89.7521 96.0281 89.6893 95.7407 89.6117L95.5392 90.358C95.2237 90.2728 94.9137 90.1714 94.61 90.0544L94.8878 89.333C94.6082 89.2254 94.3341 89.1033 94.066 88.9675L93.7167 89.6571C93.4264 89.51 93.143 89.3483 92.8674 89.1728L93.2825 88.5207C93.0293 88.3595 92.7826 88.1854 92.5433 87.999L92.0684 88.609C91.8123 88.4096 91.5643 88.1975 91.3252 87.9735L91.8536 87.4093C91.6336 87.2033 91.4214 86.9862 91.2176 86.7587L90.6418 87.2744C90.4256 87.033 90.2185 86.7809 90.0212 86.5189L90.6386 86.0539C90.4565 85.8121 90.2832 85.5611 90.1192 85.3014L89.4656 85.7142C89.2926 85.4403 89.1295 85.1576 88.977 84.8669L89.6614 84.5077C89.5203 84.2388 89.3888 83.9625 89.2673 83.6792L88.5568 83.9839C88.4292 83.6864 88.3122 83.382 88.2062 83.0713L88.9379 82.8218C88.8397 82.5338 88.7515 82.2399 88.674 81.9406L87.9257 82.1344C87.8445 81.8211 87.7743 81.5024 87.7156 81.1789L88.4761 81.0408C88.4218 80.7413 88.3778 80.4372 88.3447 80.1291L87.5761 80.2116C87.5416 79.8902 87.5183 79.5648 87.5067 79.236L88.2792 79.2086C88.2738 79.0554 88.2711 78.9013 88.2711 78.7464C88.2711 78.5915 88.2738 78.4375 88.2792 78.2842L87.5067 78.2569C87.5183 77.928 87.5416 77.6026 87.5761 77.2812L88.3447 77.3637C88.3778 77.0556 88.4218 76.7515 88.4761 76.452L87.7156 76.3139C87.7743 75.9904 87.8445 75.6717 87.9257 75.3584L88.674 75.5523C88.7515 75.253 88.8397 74.959 88.9379 74.671L88.2062 74.4215C88.3122 74.1108 88.4292 73.8064 88.5568 73.509L89.2673 73.8137C89.3888 73.5304 89.5203 73.254 89.6614 72.9851L88.977 72.6259C89.1295 72.3352 89.2926 72.0526 89.4656 71.7786L90.1192 72.1914C90.2832 71.9318 90.4565 71.6807 90.6386 71.439L90.0212 70.9739C90.2185 70.7119 90.4256 70.4599 90.6418 70.2184L91.2176 70.7341C91.4214 70.5066 91.6336 70.2895 91.8536 70.0835L91.3252 69.5193C91.5643 69.2953 91.8123 69.0833 92.0684 68.8838L92.5433 69.4938C92.7826 69.3075 93.0293 69.1333 93.2825 68.9721L92.8674 68.32C93.143 68.1445 93.4264 67.9828 93.7167 67.8357L94.066 68.5253C94.3341 68.3895 94.6082 68.2675 94.8878 68.1598L94.61 67.4384C94.9137 67.3215 95.2237 67.22 95.5392 67.1348L95.7407 67.8811C96.0281 67.8035 96.3204 67.7407 96.617 67.6934L96.4952 66.93C96.8149 66.879 97.1393 66.8445 97.4676 66.8273L97.5082 67.5992C97.6568 67.5914 97.8063 67.5875 97.9567 67.5875C98.1072 67.5875 98.2567 67.5914 98.4053 67.5992L98.4459 66.8273C98.7742 66.8445 99.0986 66.879 99.4183 66.93L99.2965 67.6934C99.5931 67.7407 99.8854 67.8035 100.173 67.8811L100.374 67.1348C100.69 67.22 101 67.3215 101.303 67.4384L101.026 68.1598C101.305 68.2675 101.579 68.3895 101.847 68.5253L102.197 67.8357C102.487 67.9828 102.77 68.1445 103.046 68.32L102.631 68.9721C102.884 69.1333 103.131 69.3075 103.37 69.4938L103.845 68.8838C104.101 69.0833 104.349 69.2953 104.588 69.5193L104.06 70.0835C104.28 70.2895 104.492 70.5066 104.696 70.7341L105.272 70.2184C105.488 70.4599 105.695 70.7119 105.892 70.9739L105.275 71.439C105.457 71.6807 105.63 71.9318 105.794 72.1914L106.448 71.7786C106.621 72.0526 106.784 72.3352 106.937 72.6259L106.252 72.9851C106.393 73.254 106.525 73.5304 106.646 73.8137L107.357 73.509C107.484 73.8064 107.601 74.1108 107.707 74.4215L106.976 74.671C107.074 74.959 107.162 75.253 107.24 75.5523L107.988 75.3584C108.069 75.6717 108.139 75.9904 108.198 76.3139L107.437 76.452C107.492 76.7515 107.536 77.0556 107.569 77.3637L108.337 77.2812Z",
    stroke: "#8FDBFF",
    strokeWidth: 1.54605,
    strokeDasharray: "1.03 1.03"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M144.182 77.2812C144.217 77.6026 144.24 77.928 144.252 78.2569L143.479 78.2842C143.484 78.4375 143.487 78.5915 143.487 78.7464C143.487 78.9013 143.484 79.0554 143.479 79.2086L144.252 79.236C144.24 79.5648 144.217 79.8902 144.182 80.2116L143.413 80.1291C143.38 80.4372 143.336 80.7413 143.282 81.0408L144.043 81.1789C143.984 81.5024 143.914 81.8211 143.833 82.1344L143.084 81.9406C143.007 82.2399 142.919 82.5338 142.82 82.8218L143.552 83.0713C143.446 83.382 143.329 83.6864 143.201 83.9839L142.491 83.6792C142.369 83.9625 142.238 84.2388 142.097 84.5077L142.781 84.8669C142.629 85.1576 142.466 85.4403 142.293 85.7142L141.639 85.3014C141.475 85.5611 141.302 85.8121 141.12 86.0539L141.737 86.5189C141.54 86.7809 141.333 87.033 141.116 87.2744L140.541 86.7587C140.337 86.9862 140.125 87.2033 139.905 87.4093L140.433 87.9735C140.194 88.1975 139.946 88.4096 139.69 88.609L139.215 87.999C138.976 88.1854 138.729 88.3595 138.476 88.5207L138.891 89.1728C138.615 89.3483 138.332 89.51 138.041 89.6571L137.692 88.9675C137.424 89.1033 137.15 89.2254 136.87 89.333L137.148 90.0544C136.844 90.1714 136.534 90.2728 136.219 90.358L136.018 89.6117C135.73 89.6893 135.438 89.7521 135.141 89.7994L135.263 90.5628C134.943 90.6138 134.619 90.6483 134.291 90.6656L134.25 89.8936C134.101 89.9014 133.952 89.9053 133.801 89.9053C133.651 89.9053 133.502 89.9014 133.353 89.8936L133.312 90.6656C132.984 90.6483 132.66 90.6138 132.34 90.5628L132.462 89.7994C132.165 89.7521 131.873 89.6893 131.585 89.6117L131.384 90.358C131.068 90.2728 130.758 90.1714 130.455 90.0544L130.733 89.333C130.453 89.2254 130.179 89.1033 129.911 88.9675L129.561 89.6571C129.271 89.51 128.988 89.3483 128.712 89.1728L129.127 88.5207C128.874 88.3595 128.627 88.1854 128.388 87.999L127.913 88.609C127.657 88.4096 127.409 88.1975 127.17 87.9735L127.698 87.4093C127.478 87.2033 127.266 86.9862 127.062 86.7587L126.487 87.2744C126.27 87.033 126.063 86.7809 125.866 86.5189L126.483 86.0539C126.301 85.8121 126.128 85.5611 125.964 85.3014L125.31 85.7142C125.137 85.4403 124.974 85.1576 124.822 84.8669L125.506 84.5077C125.365 84.2388 125.233 83.9625 125.112 83.6792L124.402 83.9839C124.274 83.6864 124.157 83.382 124.051 83.0713L124.783 82.8218C124.684 82.5338 124.596 82.2399 124.519 81.9406L123.77 82.1344C123.689 81.8211 123.619 81.5024 123.56 81.1789L124.321 81.0408C124.266 80.7413 124.223 80.4372 124.189 80.1291L123.421 80.2116C123.386 79.8902 123.363 79.5648 123.351 79.236L124.124 79.2086C124.119 79.0554 124.116 78.9013 124.116 78.7464C124.116 78.5915 124.119 78.4375 124.124 78.2842L123.351 78.2569C123.363 77.928 123.386 77.6026 123.421 77.2812L124.189 77.3637C124.223 77.0556 124.266 76.7515 124.321 76.452L123.56 76.3139C123.619 75.9904 123.689 75.6717 123.77 75.3584L124.519 75.5523C124.596 75.253 124.684 74.959 124.783 74.671L124.051 74.4215C124.157 74.1108 124.274 73.8064 124.402 73.509L125.112 73.8137C125.233 73.5304 125.365 73.254 125.506 72.9851L124.822 72.6259C124.974 72.3352 125.137 72.0526 125.31 71.7786L125.964 72.1914C126.128 71.9318 126.301 71.6807 126.483 71.439L125.866 70.9739C126.063 70.7119 126.27 70.4599 126.487 70.2184L127.062 70.7341C127.266 70.5066 127.478 70.2895 127.698 70.0835L127.17 69.5193C127.409 69.2953 127.657 69.0833 127.913 68.8838L128.388 69.4938C128.627 69.3075 128.874 69.1333 129.127 68.9721L128.712 68.32C128.988 68.1445 129.271 67.9828 129.561 67.8357L129.911 68.5253C130.179 68.3895 130.453 68.2675 130.733 68.1598L130.455 67.4384C130.758 67.3215 131.068 67.22 131.384 67.1348L131.585 67.8811C131.873 67.8035 132.165 67.7407 132.462 67.6934L132.34 66.93C132.66 66.879 132.984 66.8445 133.312 66.8273L133.353 67.5992C133.502 67.5914 133.651 67.5875 133.801 67.5875C133.952 67.5875 134.101 67.5914 134.25 67.5992L134.291 66.8273C134.619 66.8445 134.943 66.879 135.263 66.93L135.141 67.6934C135.438 67.7407 135.73 67.8035 136.018 67.8811L136.219 67.1348C136.534 67.22 136.844 67.3215 137.148 67.4384L136.87 68.1598C137.15 68.2675 137.424 68.3895 137.692 68.5253L138.041 67.8357C138.332 67.9828 138.615 68.1445 138.891 68.32L138.476 68.9721C138.729 69.1333 138.976 69.3075 139.215 69.4938L139.69 68.8838C139.946 69.0833 140.194 69.2953 140.433 69.5193L139.905 70.0835C140.125 70.2895 140.337 70.5066 140.541 70.7341L141.116 70.2184C141.333 70.4599 141.54 70.7119 141.737 70.9739L141.12 71.439C141.302 71.6807 141.475 71.9318 141.639 72.1914L142.293 71.7786C142.466 72.0526 142.629 72.3352 142.781 72.6259L142.097 72.9851C142.238 73.254 142.369 73.5304 142.491 73.8137L143.201 73.509C143.329 73.8064 143.446 74.1108 143.552 74.4215L142.82 74.671C142.919 74.959 143.007 75.253 143.084 75.5523L143.833 75.3584C143.914 75.6717 143.984 75.9904 144.043 76.3139L143.282 76.452C143.336 76.7515 143.38 77.0556 143.413 77.3637L144.182 77.2812Z",
    stroke: "#8FDBFF",
    strokeWidth: 1.54605,
    strokeDasharray: "1.03 1.03"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M141.732 109.854C141.732 109.854 140.643 111.792 139.578 112.776C140.039 120.305 133.469 137.798 117.978 141.518C131.557 139.136 141.329 126.176 141.732 109.854Z",
    fill: "#D185F2",
    fillOpacity: 0.3
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9753 116.169C94.4038 118.963 92.7205 120.862 91.9654 120.643C91.2104 120.424 90.9539 119.964 90.4553 116.711C89.9567 113.458 89.9019 113.028 90.7183 112.507C91.5347 111.987 93.5468 113.375 93.9753 116.169Z",
    fill: "url(#paint23_linear_359_179975)",
    fillOpacity: 0.4
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9587 118.482C96.4414 124.027 95.9301 128.534 95.1865 127.908C94.4428 127.283 91.7074 121.43 90.8486 117.917C89.9899 114.405 89.8881 113.155 90.6962 112.527C91.5044 111.898 93.476 112.938 94.9587 118.482Z",
    fill: "url(#paint24_linear_359_179975)",
    fillOpacity: 0.3
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M137.581 116.237C137.153 119.031 138.836 120.93 139.591 120.711C140.346 120.492 140.603 120.032 141.101 116.779C141.6 113.526 141.655 113.096 140.838 112.575C140.022 112.055 138.01 113.443 137.581 116.237Z",
    fill: "url(#paint25_linear_359_179975)",
    fillOpacity: 0.4
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M136.598 118.55C135.115 124.095 135.626 128.602 136.37 127.976C137.114 127.351 139.849 121.498 140.708 117.985C141.567 114.472 141.669 113.223 140.86 112.594C140.052 111.966 138.081 113.006 136.598 118.55Z",
    fill: "url(#paint26_linear_359_179975)",
    fillOpacity: 0.3
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M173.3 122.045C160.109 124.385 142.394 121.55 141.787 118.125C141.179 114.701 157.357 109.417 170.427 107.481C183.497 105.545 197.148 102.914 197.982 107.62C198.816 112.327 186.491 119.705 173.3 122.045Z",
    fill: "url(#paint27_linear_359_179975)",
    fillOpacity: 0.3
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4101 122.045C72.6011 124.385 90.3155 121.55 90.9232 118.125C91.5308 114.701 75.3525 109.417 62.2829 107.481C49.2134 105.545 35.5623 102.914 34.7281 107.62C33.8939 112.327 46.2191 119.705 59.4101 122.045Z",
    fill: "url(#paint28_linear_359_179975)",
    fillOpacity: 0.3
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M171.477 119.548C158.286 121.888 140.571 119.053 139.964 115.628C139.356 112.203 155.534 106.92 168.604 104.984C181.673 103.048 195.324 100.417 196.159 105.123C196.993 109.83 184.668 117.208 171.477 119.548Z",
    fill: "url(#paint29_linear_359_179975)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2324 119.548C74.4234 121.888 92.1378 119.053 92.7454 115.628C93.3531 112.203 77.1748 106.92 64.1052 104.984C51.0356 103.048 37.3846 100.417 36.5504 105.123C35.7162 109.83 48.0414 117.208 61.2324 119.548Z",
    fill: "url(#paint30_linear_359_179975)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M168.469 104.751C181.491 102.774 195.104 100.176 195.831 104.276C195.831 104.276 194.465 101.288 169.242 105.694C140.115 110.781 140.182 114.878 140.182 114.878C139.652 111.895 155.448 106.727 168.469 104.751Z",
    fill: "#D185F2",
    fillOpacity: 0.3
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2396 104.751C51.2184 102.774 37.6048 100.176 36.8782 104.276C36.8782 104.276 38.2444 101.288 63.4675 105.694C92.5939 110.781 92.5274 114.878 92.5274 114.878C93.0568 111.895 77.2608 106.727 64.2396 104.751Z",
    fill: "#D185F2",
    fillOpacity: 0.3
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M171.476 119.548C184.667 117.208 196.993 109.829 196.158 105.123C196.032 104.411 195.613 103.867 194.946 103.463C194.946 103.463 190.138 107.633 178.602 112.914C162.943 120.083 156.319 120.238 154.955 120.173C154.863 120.165 154.772 120.158 154.681 120.151C154.681 120.151 154.769 120.164 154.955 120.173C160.271 120.59 166.231 120.478 171.476 119.548Z",
    fill: "url(#paint31_linear_359_179975)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2326 119.548C48.0416 117.208 35.7164 109.829 36.5506 105.123C36.6768 104.411 37.0963 103.867 37.7628 103.463C37.7628 103.463 42.5714 107.633 54.1071 112.914C69.7656 120.083 76.3901 120.238 77.754 120.173C77.8456 120.165 77.937 120.158 78.0281 120.151C78.0281 120.151 77.94 120.164 77.754 120.173C72.4383 120.59 66.4778 120.478 61.2326 119.548Z",
    fill: "url(#paint32_linear_359_179975)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M171.69 108.446C168.637 109.034 164.086 108.793 163.992 108.306C163.898 107.819 167.537 106.624 171.07 106.021C174.604 105.418 178.777 105.358 178.846 105.711C178.914 106.064 174.742 107.858 171.69 108.446Z",
    fill: "url(#paint33_linear_359_179975)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0194 108.446C64.0717 109.034 68.6233 108.793 68.7172 108.306C68.8111 107.819 65.1722 106.624 61.6388 106.021C58.1054 105.418 53.9315 105.358 53.8635 105.711C53.7954 106.064 57.9671 107.858 61.0194 108.446Z",
    fill: "url(#paint34_linear_359_179975)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.609,
    cy: 159.408,
    rx: 31.6588,
    ry: 11.408,
    fill: "url(#paint35_radial_359_179975)",
    fillOpacity: 0.4
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M115.895 26.3733L115.895 48.7936",
    stroke: "url(#paint36_linear_359_179975)",
    strokeWidth: 1.30481,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.718,
    cy: 25.5668,
    rx: 4.7184,
    ry: 4.56684,
    fill: "url(#paint37_linear_359_179975)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 115.5,
    cy: 26,
    rx: 9.5,
    ry: 9,
    stroke: "url(#paint38_linear_359_179975)",
    strokeWidth: 1.54011,
    strokeLinecap: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 115.5,
    cy: 26,
    rx: 13.5,
    ry: 13,
    stroke: "url(#paint39_linear_359_179975)",
    strokeOpacity: 0.8,
    strokeWidth: 1.54011,
    strokeLinecap: "round"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 115.5,
    cy: 26,
    rx: 17.5,
    ry: 17,
    stroke: "url(#paint40_linear_359_179975)",
    strokeOpacity: 0.6,
    strokeWidth: 1.54011,
    strokeLinecap: "round"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 115.5,
    cy: 26,
    rx: 21.5,
    ry: 21,
    stroke: "url(#paint41_linear_359_179975)",
    strokeOpacity: 0.4,
    strokeWidth: 1.54011,
    strokeLinecap: "round"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 115.5,
    cy: 26,
    rx: 25.5,
    ry: 25,
    stroke: "url(#paint42_linear_359_179975)",
    strokeOpacity: 0.2,
    strokeWidth: 1.54011,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M38.0556 40.1873H49.0404C48.3081 32.1037 59 29.7522 59 20.9337C59 11.6744 52.5556 8 44.5 8C38.6414 8 33.5884 10.7925 30 14.9078L36.8838 21.2277C38.7879 19.464 40.399 18.1412 42.8889 18.1412C45.0859 18.1412 46.9899 19.17 46.9899 21.8156C46.9899 26.5187 36.5909 30.634 38.0556 40.1873ZM43.4747 59C47.7222 59 50.798 55.6196 50.798 51.3573C50.798 47.0951 47.7222 43.7147 43.4747 43.7147C39.2273 43.7147 36.1515 47.0951 36.1515 51.3573C36.1515 55.6196 39.2273 59 43.4747 59Z",
    fill: "#2F2DC1"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M4.16667 126.04H9.84849C9.4697 121.761 15 120.516 15 115.847C15 110.945 11.6667 109 7.5 109C4.4697 109 1.85606 110.478 0 112.657L3.56061 116.003C4.54545 115.069 5.37879 114.369 6.66667 114.369C7.80303 114.369 8.78788 114.914 8.78788 116.314C8.78788 118.804 3.40909 120.983 4.16667 126.04ZM6.9697 136C9.16667 136 10.7576 134.21 10.7576 131.954C10.7576 129.697 9.16667 127.908 6.9697 127.908C4.77273 127.908 3.18182 129.697 3.18182 131.954C3.18182 134.21 4.77273 136 6.9697 136Z",
    fill: "#2F2DC1"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116,
    cy: 92.5,
    rx: 3,
    ry: 4.5,
    fill: "url(#paint43_linear_359_179975)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M207.706 88.9741H220.206C219.372 79.9395 231.539 77.3112 231.539 67.4553C231.539 57.1066 224.206 53 215.039 53C208.372 53 202.622 56.121 198.539 60.7205L206.372 67.7839C208.539 65.8127 210.372 64.3343 213.206 64.3343C215.706 64.3343 217.872 65.4842 217.872 68.4409C217.872 73.6974 206.039 78.2968 207.706 88.9741ZM213.872 110C218.706 110 222.206 106.222 222.206 101.458C222.206 96.6945 218.706 92.9164 213.872 92.9164C209.039 92.9164 205.539 96.6945 205.539 101.458C205.539 106.222 209.039 110 213.872 110Z",
    fill: "#2F2DC1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_359_179975",
    x1: 139.216,
    y1: 119.516,
    x2: 83.2161,
    y2: 119.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DE0FF",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_359_179975",
    x1: 89.7861,
    y1: 112.808,
    x2: 141.97,
    y2: 112.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7EAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149193,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519605,
    stopColor: "#D1D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87384,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9E8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_359_179975",
    x1: 89.7861,
    y1: 119.568,
    x2: 110,
    y2: 126.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.693995,
    stopColor: "#C3DFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_359_179975",
    x1: 141.971,
    y1: 119.568,
    x2: 121.757,
    y2: 126.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.693995,
    stopColor: "#C3DFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_359_179975",
    x1: 89.793,
    y1: 112.808,
    x2: 141.965,
    y2: 112.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7EAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00520833,
    stopColor: "#B7EAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149193,
    stopColor: "#E9E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519605,
    stopColor: "#F8F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87384,
    stopColor: "#E9E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9E8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_359_179975",
    x1: 115.213,
    y1: 113.163,
    x2: 115.139,
    y2: 115.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336756,
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_359_179975",
    x1: 123.651,
    y1: 115.998,
    x2: 123.848,
    y2: 118.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771045,
    stopColor: "#CCD7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_359_179975",
    x1: 131.786,
    y1: 131.864,
    x2: 130.85,
    y2: 131.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_359_179975",
    x1: 163.346,
    y1: 67.922,
    x2: 55.2897,
    y2: 67.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DE0FF",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_359_179975",
    x1: 148.18,
    y1: 64.7586,
    x2: 156.803,
    y2: 39.3953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821767,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_359_179975",
    x1: 165.627,
    y1: 58.5543,
    x2: 140.351,
    y2: 50.6948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369241,
    stopColor: "#C2DEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687753,
    stopColor: "#B4CDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABBFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_359_179975",
    x1: 83.6079,
    y1: 64.6559,
    x2: 74.9846,
    y2: 39.2925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821767,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_359_179975",
    x1: 66.0426,
    y1: 58.4517,
    x2: 91.3193,
    y2: 50.5922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369241,
    stopColor: "#C2DEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687753,
    stopColor: "#B4CDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABBFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_359_179975",
    x1: 65.5469,
    y1: 63.8644,
    x2: 166.24,
    y2: 63.8644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7EAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149193,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519605,
    stopColor: "#D1D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87384,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9E8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_359_179975",
    x1: 88.3843,
    y1: 51.8005,
    x2: 143.364,
    y2: 51.8005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149193,
    stopColor: "#BCBAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519605,
    stopColor: "#BBBAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87384,
    stopColor: "#97B1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91C5FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_359_179975",
    x1: 72.2946,
    y1: 80.931,
    x2: 87.1291,
    y2: 73.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3DFFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_359_179975",
    x1: 80.3489,
    y1: 81.3157,
    x2: 154.579,
    y2: 68.9814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1DA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.470359,
    stopColor: "#3134D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_359_179975",
    x1: 108.223,
    y1: 78.286,
    x2: 151.569,
    y2: 68.7529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602DDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3134D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_359_179975",
    x1: 115.893,
    y1: 62.9014,
    x2: 115.893,
    y2: 64.7229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771045,
    stopColor: "#C7C5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_359_179975",
    x1: 160.745,
    y1: 66.9772,
    x2: 158.536,
    y2: 66.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_359_179975",
    x1: 70.0825,
    y1: 71.8461,
    x2: 73.0258,
    y2: 70.8108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.387196,
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_359_179975",
    x1: 74.4813,
    y1: 81.495,
    x2: 75.6594,
    y2: 80.5098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_359_179975",
    x1: 116.474,
    y1: 50.5656,
    x2: 116.474,
    y2: 49.1544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.458744,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_359_179975",
    x1: 90.4543,
    y1: 116.704,
    x2: 93.9746,
    y2: 116.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E2DDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_359_179975",
    x1: 90.5957,
    y1: 117.846,
    x2: 94.1487,
    y2: 117.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E2DDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_359_179975",
    x1: 141.102,
    y1: 116.772,
    x2: 137.582,
    y2: 116.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E2DDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_359_179975",
    x1: 140.961,
    y1: 117.914,
    x2: 137.408,
    y2: 117.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E2DDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_359_179975",
    x1: 141.979,
    y1: 119.211,
    x2: 202.383,
    y2: 108.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DE0FF",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_359_179975",
    x1: 90.7305,
    y1: 119.211,
    x2: 30.3271,
    y2: 108.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DE0FF",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_359_179975",
    x1: 140.519,
    y1: 115.14,
    x2: 195.387,
    y2: 103.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295244,
    stopColor: "#E4E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593241,
    stopColor: "#DBDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_359_179975",
    x1: 92.1901,
    y1: 115.14,
    x2: 37.3224,
    y2: 103.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295244,
    stopColor: "#E4E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593241,
    stopColor: "#DBDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_359_179975",
    x1: 179.005,
    y1: 111.849,
    x2: 181.589,
    y2: 116.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7B5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_359_179975",
    x1: 53.7037,
    y1: 111.849,
    x2: 51.1196,
    y2: 116.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7B5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_359_179975",
    x1: 171.294,
    y1: 106.397,
    x2: 171.832,
    y2: 108.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_359_179975",
    x1: 61.4146,
    y1: 106.397,
    x2: 60.8772,
    y2: 108.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4FC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_359_179975",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.609 159.408) rotate(90) scale(10.1211 28.0875)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AE7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#9AE7FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_359_179975",
    x1: 116.395,
    y1: 26.3733,
    x2: 116.395,
    y2: 48.7936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92E8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509934,
    stopColor: "#C1E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D0FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_359_179975",
    x1: 115.718,
    y1: 21,
    x2: 115.718,
    y2: 30.1337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCECEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421216,
    stopColor: "#FFC8BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_359_179975",
    x1: 115.5,
    y1: 17,
    x2: 115.5,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E54322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509934,
    stopColor: "#F9674A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_359_179975",
    x1: 115.5,
    y1: 13,
    x2: 115.5,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E54322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509934,
    stopColor: "#F9674A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_359_179975",
    x1: 115.5,
    y1: 9,
    x2: 115.5,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E54322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509934,
    stopColor: "#F9674A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_359_179975",
    x1: 115.5,
    y1: 5,
    x2: 115.5,
    y2: 47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E54322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509934,
    stopColor: "#F9674A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_359_179975",
    x1: 115.5,
    y1: 1,
    x2: 115.5,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E54322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509934,
    stopColor: "#F9674A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_359_179975",
    x1: 116,
    y1: 88,
    x2: 116,
    y2: 97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771045,
    stopColor: "#C7C5FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteModalBot);
export default __webpack_public_path__ + "static/media/delete-modal-bot.fe6d9998e80ec3396c73429772e74ee1.svg";
export { ForwardRef as ReactComponent };